export function routesAddArea(routes, country) {
  if (!country) {
    return routes;
  }
  let countryLangMap = {
    CN: "zh", // 中国 - 简体中文
    SG: "en", // 新加坡 - 英语
    KR: "ko", // 韩国 - 韩语
    ID: "id", // 印度尼西亚 - 印尼语
    TH: "th", // 泰国 - 泰语
    KH: "km", // 柬埔寨 - 高棉语
    PH: "en", // 菲律宾 - 英语（菲律宾语也很常用，但这里简化为英语）
    AE: "ar", // 阿联酋 - 阿拉伯语
    SA: "ar", // 沙特阿拉伯 - 阿拉伯语
    US: "en", // 美国 - 英语
    KE: "en", // 肯尼亚 - 英语（斯瓦希里语也广泛使用）
    ET: "am", // 埃塞俄比亚 - 阿姆哈拉语
    TZ: "sw", // 坦桑尼亚 - 斯瓦希里语
    UG: "en", // 乌干达 - 英语（斯瓦希里语也广泛使用）
    RW: "rw", // 卢旺达 - 卢旺达语
    ZM: "en", // 赞比亚 - 英语
    CD: "fr", // 刚果民主共和国 - 法语（还有其他语言）
    CG: "fr", // 刚果共和国 - 法语
    AO: "pt", // 安哥拉 - 葡萄牙语
    MZ: "pt", // 莫桑比克 - 葡萄牙语
    ZW: "en", // 津巴布韦 - 英语
    NA: "en", // 纳米比亚 - 英语（还有其他语言）
    NG: "en", // 尼日利亚 - 英语（还有豪萨语、约鲁巴语等）
    GH: "en", // 加纳 - 英语
    // 其他国家的映射...
  };
  let countryArr = Object.keys(countryLangMap);
  // ["CN","SG","KR","ID","TH","KH","PH","AE","SA","US","KE","ET","TZ","UG","RW","ZM","CD","CG","AO","MZ","ZW","NA","NG","GH"]
  // let browserLanguage = navigator.language || navigator.userLanguage;
  // 可能得到类似 "en - US"、"zh - CN" 这样的值，我们可能只需要前面的主语言部分
  // browserLanguage = browserLanguage ? browserLanguage.split("-")[0] : null;
  // 根据获取到的国家对路由进行处理
  if (country && countryArr.includes(country)) {
    // 给路由加上前缀
    let addLanguageSuffix = (lang, route) => {
      const newRoute = { ...route };
      newRoute.path = route.path === "/" ? `/${lang}` : `/${lang}${route.path}`;
      return newRoute;
    };
    routes.unshift({ path: "/", redirect: country ? "/" + country : "/" });
    routes = routes.map((v, index) => {
      if (index == 0) {
        return v;
      } else {
        return addLanguageSuffix(country, v);
      }
    });
    return routes;
  } else {
    return routes;
  }
}
